import { gql } from '@apollo/client';
import { BilderitReportType } from '@/generated/codegen';

export const BILDERIT_REPORT_TYPES = [
  {
    value: BilderitReportType.AiMachineNoticesWeeklySummary,
    label: 'Resumen semanal IA de novedades',
    feature_flag: 'ia_report',
    periodicity: 'weekly' as const,
    scope: 'project' as const,
  },
  {
    value: BilderitReportType.DocumentsExpiring,
    label: 'Vencimiento de documentación',
    feature_flag: 'documents_report',
    periodicity: 'weekly' as const,
    scope: 'both' as const,
  },
  {
    value: BilderitReportType.UpcomingServices,
    label: 'Próximos Services',
    feature_flag: 'services_report',
    periodicity: 'weekly' as const,
    scope: 'project' as const,
  },
  {
    value: BilderitReportType.TelemetryMonthly,
    label: 'Reporte Mensual de Telemetría',
    feature_flag: 'telemetry_report',
    periodicity: 'monthly' as const,
    scope: 'company' as const,
  },
  {
    value: BilderitReportType.MachineNoticesDaily,
    label: 'Resumen diario de novedades',
    feature_flag: 'machine_notices_report',
    periodicity: 'daily' as const,
    scope: 'both' as const,
  },
];

export const GET_COMPANY_ALERTS = gql`
  query GetCompanyAlerts($context: Context!) {
    getCompanyAlerts(context: $context) {
      expired_documents_count
      overdue_services_count
      open_critical_machine_notices_count
    }
  }
`;

export const REPORT_SUBSCRIPTION_FIELDS = gql`
  fragment ReportSubscriptionFields on BilderitReportSubscription {
    id
    company {
      id
      name
    }
    project {
      id
      name
    }
    report_type
    email
    created_by
  }
`;

export const GET_REPORT_SUBSCRIPTIONS = gql`
  query GetMyReportSubscriptions($context: Context) {
    getMyBilderitReportSubscriptions(context: $context) {
      ...ReportSubscriptionFields
    }
  }
`;

export const SUBSCRIBE_TO_BILDERIT_REPORT = gql`
  mutation SubscribeToBilderitReport($input: SubscribeToBilderitReportInput!) {
    subscribeToBilderitReport(input: $input) {
      ...ReportSubscriptionFields
    }
  }
`;

export const UNSUBSCRIBE_FROM_BILDERIT_REPORT = gql`
  mutation UnsubscribeFromBilderitReport($id: ID!) {
    unsubscribeFromBilderitReport(id: $id)
  }
`;

export const GET_BTRACK_ACCESS_TOKEN = gql`
  query GetBtrackAccessToken($company_id: Int!) {
    getBtrackAccessToken(company_id: $company_id)
  }
`;

export const GET_BTRACK_DEMO_ACCESS_TOKEN = gql`
  query GetBtrackDemoAccessToken {
    getBtrackDemoAccessToken
  }
`;
